import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from '../../../../../core/carregar-perfil';
import { ParticipanteReuniao } from '../../../../../core/participante-reuniao';

@Component({
  selector: 'listar-participantes-reuniao',
  templateUrl: './listar-participantes-reuniao.component.html',
  styleUrls: ['./listar-participantes-reuniao.component.css']
})
export class ListarParticipantesReuniaoComponent implements OnInit {

  @Output() onAtualizarParticipante = new EventEmitter();
  @Output() onAbertoFormAdicaoParticipante = new EventEmitter();
  @Input() participantesReuniao: ParticipanteReuniao[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['nome', 'origem', 'acoes'];
  dataSource: MatTableDataSource<ParticipanteReuniao> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();


  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.carregarLista();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["participantesReuniao"] && !_.isEmpty(changes["participantesReuniao"].currentValue)) {
      this.carregarLista();
    }
  }


  carregarLista() {
      if (_.isEmpty(this.participantesReuniao)) {
        this.mostrarTabela = false;
        this.msg = 'Nenhum participante cadastrado.';
      } else {
        this.dataSource.data = this.participantesReuniao;
        this.mostrarTabela = true;
    }
  }

  deletar(participante: any): void {
    const index = this.participantesReuniao.indexOf( this.participantesReuniao.find(col => col === participante));
    if (index >= 0) {
      this.participantesReuniao.splice(index, 1);
      this.carregarLista();
    }
  }

  atualizar(participanteReuniao: ParticipanteReuniao) {
    this.onAtualizarParticipante.emit(participanteReuniao);
  }

  abrirFormAdicaoParticipante() {
    this.onAbertoFormAdicaoParticipante.emit(true);
  }

}
